import {createRouter, createWebHistory} from 'vue-router'
import dashboard from "./app/contact/dashboard";
import ContactTable from "./app/contact/ContactTable";
import User from "./app/user/user.vue";
import UserDetails from "./app/user/UserDetails.vue";
import ContactDashboard from "./app/dashboards/ContactDashboard.vue";
import authService from "./mixins/auth-service"
import Login from "./app/auth/Login.vue";
import SignUp from "./app/auth/SignUp.vue";
import ForgotPassword from "./app/auth/ForgotPassword.vue";
import Error from "./app/auth/Error.vue";
import UserFeed from "./app/user/UserFeed.vue";
import UserFeed2 from "./app/user/UserFeed2.vue";
import AccountActivation from "./app/auth/AccountActivation.vue";
import ResetPassword from "./app/auth/ResetPassword.vue";
import DashboardOne from "./app/dashboards/DashboardOne.vue";
import Configuration from "./app/configuration/configuration.vue";
import ContactDashboardCard from "./app/dashboards/ContactDashboardCard.vue";
import UserMe from "./app/user/UserMe.vue";
import VideoList from "./app/watch/VideoList.vue";
import VideoDetail from "./app/watch/VideoDetail.vue";
import SmsWallet from "./app/messaging/SmsWallet.vue";
import SmsBuyCredits from "./app/messaging/SmsBuyCredits.vue";
import SmsDashboard from "./app/messaging/SmsDashboard.vue";
import SendSms from "./app/messaging/SendSms.vue";


const routes = [
    {
        name: "Configuration",
        component: Configuration,
        path: "/configuration",
    },
    {
        name: "Login",
        component: Login,
        path: "/login",
    },
    {
        name: "SignUp",
        component: SignUp,
        path: "/sign-up",
    },
    {
        name: "AccountActivation",
        component: AccountActivation,
        path: "/activate-account",
        props: (route) => ({
            token: route.query.token,
            mode: route.query.mode,
        }),
    },
    {
        name: "ForgotPassword",
        component: ForgotPassword,
        path: "/forgot-password",
    },
    {
        name: "ResetPassword",
        component: ResetPassword,
        path: "/reset-password",
        props: (route) => ({
            token: route.query.token,
        }),
    },
    {
        name: "Error",
        component: Error,
        path: "/error",
        props: (route) => ({
            code: route.query.code,
            message: route.query.message,
        }),
    },
    {
        name: "ContactDashboard",
        component: ContactDashboard,
        path: "/contact-dashboard",
        alias: '/'
    },
    {
        name: "UserMe",
        component: UserMe,
        path: "/me"
    },
    {
        name: "ContactDashboardCard",
        component: ContactDashboardCard,
        path: "/contact-dashboard2",
        alias: '/'
    },
    {
        name: "UserFeed",
        component: UserFeed,
        path: "/feed"
    },
    {
        name: "UserFeed2",
        component: UserFeed2,
        path: "/feed-2"
    },
    {
        name: "VideoList",
        component: VideoList,
        path: "/watch"
    },
    {
        name: "VideoDetails",
        component: VideoDetail,
        path: "/watch/:id"
    },
    {
        name: "DashboardOne",
        component: DashboardOne,
        path: "/keep",
    },
    {
        name: "dashboard",
        component: dashboard,
        path: "/dashboard",
        props: (route) => ({
            page: route.query.page
        }),
    },
    {
        name: "ContactTable",
        component: ContactTable,
        path: "/table",
    },
    {
        name: "User",
        component: User,
        path: "/users",
        props: (route) => ({
            page: route.query.page,
            first_name: route.query.first_name,
            middle_name: route.query.middle_name,
            last_name: route.query.last_name,
            email: route.query.email,
            birthday_month: route.query.birthday_month,
            marital_status: route.query.marital_status,
            wofbi_status: route.query.wofbi_status,
            water_baptism: route.query.water_baptism,
            service_unit: route.query.service_unit,
            attendance_month: route.query.attendance_month,
            attendance_year: route.query.attendance_year,
            sort: route.query.sort,
            size: route.query.size,
        })
    },
    {
        name: "UserDetails",
        component: UserDetails,
        path: "/users/:id"
    },
    {
        name: "SmsDashboard",
        component: SmsDashboard,
        path: "/sms"
    },
    {
        name: "SendSms",
        component: SendSms,
        path: "/sms/send"
    },
    {
        name: "SmsBuyCredits",
        component: SmsBuyCredits,
        path: "/sms/credits",
        props: (route) => ({
            report: route.query.report,
            purchase_id: route.query.purchase_id,
        })
    },
    {
        name: "SmsWallet",
        component: SmsWallet,
        path: "/sms/wallet"
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeResolve((to, from, next) => {

    if (authService.methods.isAuthPages(to.name)) {
        next();
    } else if (!authService.methods.loggedIn()) {
        next('/login');
    } else if (authService.methods.loginTimeout()) {
        next('/login');
    } else if (authService.methods.isPermitAll(to.name)) {
        next();
    } else if (!authService.methods.hasPrivilege(to.name)) {
        window.location.replace('/error?code=404&message=Access Denied');
    } else {
        next();
    }

})


export default router;



